<template>
  <div
    style="text-align: right;"
  >
    <el-tooltip
      v-if="file.id"
      class="item"
      effect="dark"
      content="Letöltés"
      placement="top"
    >
      <el-button
        size="mini"
        icon="el-icon-download"
        @click="downloadFile"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      content="Módosítás"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-button
        size="mini"
        icon="el-icon-edit"
        @click="updateFile"
      />
    </el-tooltip>
    <el-tooltip
      class="item"
      effect="dark"
      :content="'Törlés'"
      placement="top"
      style="margin-left: 5px;"
    >
      <el-popover
        placement="bottom"
        width="171"
        v-model="deleteConfirmVisible"
      >
        <p>Biztosan törölni szeretnéd?</p>
        <div style="text-align: right; margin: 0">
          <el-button
            size="mini"
            type="text"
            @click="deleteConfirmVisible = false"
          >
            Mégse
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="deleteFile"
          >
            Törlés
          </el-button>
        </div>
        <el-button
          slot="reference"
          size="mini"
          icon="el-icon-delete"
        />
      </el-popover>
    </el-tooltip>
  </div>
</template>

<script>
  export default {
    props: ['file'],
    data() {
      return {
        deleteConfirmVisible: false
      };
    },

    methods: {
      downloadFile() {
        window.open(this.file.file.path);
      },
      async deleteFile() {
        this.deleteConfirmVisible = false;
        this.$emit('delete', this.file);
      },
      updateFile() {
        this.$emit('update', this.file);
      }
    }
  };
</script>
